import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import Calendar from "../Calendar";
import SvgDisableInfo from "./SvgDisableInfo";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { FieldValues, UseFormReturn } from "react-hook-form";

interface Props {
  productState: IuseProductHasAttrsResult;
  form: UseFormReturn<FieldValues, any>;
}

const CalendarNotAvailable: React.FC<Props> = ({ productState, form }) => {
  const { shouldConfig, variantNotExist, requiredAddonsNotChosen, outOfStock } =
    productState;
  const t = useTranslation();
  return (
    <div className="calendar-disabled">
      <Calendar form={form} product={undefined} />
      <div className="disable-container">
        <div className="disabled-info">
          <SvgDisableInfo />
          {shouldConfig
            ? t.choose_consultation
            : variantNotExist
            ? t.this_variant_not_available
            : outOfStock
            ? t.out_of_stock
            : requiredAddonsNotChosen
            ? t.choose_required_addons
            : t.sell_disabled}
        </div>
      </div>
    </div>
  );
};

export default CalendarNotAvailable;
